{
  "add_metric": "Add key result",
  "all_goals": "All goals",
  "assignees": "Assignees",
  "at_risk": "At risk",
  "closed_goals": "Closed goals",
  "company_goal": "Strategic goal",
  "company_goal_caption": "Create a strategic wide target",
  "confidence": "Confidence",
  "confidence_level": "Confidence level",
  "count_key_results_in_goal": "Count key results in goal",
  "create_goal": "Create goal",
  "create_subgoal": "Create sub-goal",
  "current_value": "Current value",
  "deadline": "Deadline",
  "delete_goal": "Delete goal",
  "delete_goal_confirmation": "Are you sure you want to delete this goal? This action cannot be undone",
  "delete_goal_with_subgoals_question": "This goal contains subgoals. What would you like to do with them?",
  "delete_metric_confirm": "Are you sure you want to delete this key result?",
  "delete_update": "Delete update",
  "delete_update_confirm": "Are you sure you want to delete this update?",
  "department_goal": "Department goal",
  "department_goal_caption": "Owner will be head of department",
  "due_date_was": "Due date was {date}",
  "edit_goal": "Edit goal",
  "edit_metric": "Edit key result",
  "edit_metrics": "Edit key results",
  "edit_update": "Edit update",
  "employee_goal": "Personal goal",
  "employee_goal_caption": "Owner will be dedicated employee",
  "expand_parent_chain": "Show parent goals",
  "explore": "Explore",
  "end_date_from": "End date from",
  "end_date_to": "End date to",
  "goal": "Goal",
  "goal_not_found": "We couldn't find this goal",
  "goal_not_found_description": "The goal you are looking for does not exist or has been deleted",
  "goal_updated": "Goal updated",
  "goals": "Goals",
  "notification_settings_goals_caption": "When goals are created, updated, or completed",
  "notification_settings_key_results_title": "Key results",
  "notification_settings_key_results_caption": "When key results are updated",
  "goals_empty_state_description": "Create your first goal to start tracking progress",
  "goals_empty_state_title": "No goals yet",
  "initiatives_goals": "Initiatives",
  "last_update": "Last update",
  "last_updated": "Updated {time}",
  "metric_deleted": "Key result deleted",
  "metric_type": "Key result type",
  "metric_type_boolean": "Yes/No",
  "metric_type_currency": "Currency",
  "metric_type_number": "Number",
  "metric_type_percentage": "Percentage",
  "metrics": "Key results",
  "my_goals": "My goals",
  "new_update": "New update",
  "no_goals": "No goals",
  "no_metrics": "No key results assigned for this objective",
  "no_metrics_description": "Add key results to track the progress of this goal",
  "off_track": "Off track",
  "on_track": "On track",
  "open_goals": "Open goals",
  "overdue": "Overdue {days}",
  "owner_type": "Owner type",
  "parent_goal": "Parent goal",
  "percent_completed": "{percent} completed",
  "permissions_company_description": "Create, edit and delete company-level goals",
  "permissions_company_title": "Company goals",
  "permissions_department_all_description": "Create, edit and delete goals for all departments",
  "permissions_department_all_title": "All department goals",
  "permissions_department_own_description": "Create, edit and delete goals for own department",
  "permissions_department_own_title": "Own department goals",
  "permissions_module_description": "Access to the goals module",
  "permissions_module_title": "Goals module",
  "permissions_team_all_description": "Create, edit and delete goals for all teams",
  "permissions_team_all_title": "All team goals",
  "permissions_team_own_description": "Create, edit and delete goals for own team",
  "permissions_team_own_title": "Own team goals",
  "personal_goals": "Personal goals",
  "privacy_private": "Private",
  "privacy_public": "Public",
  "quarter_format": "Q{quarter} {year}",
  "recent_updates": "Recent updates",
  "search_goals": "All goals",
  "show_active_only": "Show active only",
  "show_all": "Show all",
  "show_completed": "Show completed",
  "specify_date": "Specify date",
  "specify_date_description": "The date can only be today or in the past",
  "start_date_from": "Start date from",
  "start_date_to": "Start date to",
  "start_value": "Start value",
  "status_active": "Active",
  "status_cancelled": "Cancelled",
  "status_completed": "Completed",
  "status_failed": "Not achieved",
  "strategic_goals": "Strategic",
  "sub_goals": "Sub goals",
  "sub_goals_empty": "No sub goals have been added yet",
  "subgoals_delete_all": "Delete all subgoals",
  "subgoals_empty_add": "Add sub-goal",
  "subgoals_empty_description": "Add sub-goals to break this objective into measurable milestones",
  "subgoals_empty_title": "No sub-goals",
  "subgoals_move_to_parent": "Move subgoals to parent level",
  "target_value": "Target value",
  "team_goal": "Team goal",
  "team_goal_caption": "Owner will be head of team",
  "timeline": "Timeline",
  "values": "Values",
  "view_goal": "View goal",
  "visible_to": "Visible to",
  "weight": "Weight"
}
